import React from 'react'
import styled from 'styled-components'
import theme from 'stories/utils/theme'
import Summary from 'assets/homepage-redesign/assets/summary.svg'
import { Body2 } from 'stories/elements/Typography/Text'
import _useTranslation from 'lib/hooks/_useTranslation'

const AssetWrapper = styled.div`
    width: 350px;
    height: 380px;
    border-radius: 24px;
    background: linear-gradient(180deg, #061c31 0%, #14183a 100%);
    position: relative;
    box-shadow: 0px 12px 24px 0px #00000033, 0px 36px 36px 0px #0bd0bd80;
    padding: 18px;
    display: flex;
    flex-direction: column;

    &::before {
        content: '';
        position: absolute;
        inset: 0;
        border-radius: 24px;
        padding: 5px;
        background: linear-gradient(180deg, #8bbdff 0%, #03cce6 100%);
        -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
        -webkit-mask-composite: xor;
        mask-composite: exclude;
        pointer-events: none;
    }
    @media (max-width: 860px) {
        width: 300px;
        height: 325px;
        padding: 14px;
        border-radius: 20px;
        &::before {
            border-radius: 20px;
        }
    }
`

const Header = styled.div`
    background: linear-gradient(90deg, #053154 0%, #004a54 100%);
    padding: 10px 14px;
    display: flex;
    align-items: center;
    gap: 14px;
    border-radius: 50px;
    p {
        max-width: 190px;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        font-family: var(--font-inter);
        font-weight: 650;
        font-size: 16px;
        line-height: 20px;
        letter-spacing: 0.4px;
    }
    @media (max-width: 860px) {
        padding: 8px 12px;
        gap: 10px;
        p {
            max-width: 150px;
        }
    }
`

const IconWrapper = styled.div`
    width: 49px !important;
    height: 49px !important;
    border-radius: 100%;
    border: 2px solid rgba(255, 255, 255, 0.15);
    background: linear-gradient(180.4deg, #0075c2 0.35%, #017c8c 99.65%);
    display: flex;
    align-items: center;
    justify-content: center;
    svg {
        scale: 0.9;
    }
    @media (max-width: 860px) {
        width: 42px !important;
        height: 42px !important;
        svg {
            scale: 0.8;
        }
    }
`

const ContentWrapper = styled.div`
    height: 304px;
    overflow: hidden;
    position: relative;
    text-align: left;
    background: rgba(6, 28, 49, 0.4);
    border-radius: 14px;
    padding: 18px;
    flex: 1;

    &::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 116px;
        background: linear-gradient(180deg, rgba(13, 26, 54, 0) 0%, #0c1b35 100%);
        pointer-events: none;
    }
    @media (max-width: 860px) {
        height: 260px;
        padding: 14px;
        border-radius: 12px;
    }
`

const ContentTitle = styled(Body2)`
    padding-bottom: 11px;
    font-weight: 450;
    text-align: left !important;
`

const StyledList = styled.ul`
    list-style-type: none;
    padding: 0;
    margin: 0;
    text-align: left;
`

const StyledListItem = styled.li`
    display: flex;
    text-align: left !important;
    margin: 0;
    padding-bottom: 11px;

    p {
        font-family: var(--font-inter);
        font-weight: 400;
        font-size: 16px;
        line-height: 24px;
        letter-spacing: 0.56px;
        text-align: left !important;
    }
    @media (max-width: 860px) {
        p {
            font-size: 14px;
            line-height: 20px;
            letter-spacing: 0.4px;
        }
    }
    &:before {
        content: '';
        display: block;
        min-width: 7px;
        height: 7px;
        border-radius: 50%;
        background: ${theme.colors.white};
        margin-right: 11px;
        margin-top: 7px;
    }
`

const AiSummaryAsset: React.FC = () => {
    const { t } = _useTranslation('homepage')

    const listItems = [t('homepage/aiSummaryUnitContent')]

    return (
        <AssetWrapper>
            <Header>
                <IconWrapper>
                    <Summary />
                </IconWrapper>

                <Body2 fontSize={16} fontWeight={650} color={'#F9F9F9'} fontFamily="var(--font-inter)">
                    {t('homepage/aiSummaryStudyGuideTitle')}
                </Body2>
                <svg
                    width="18"
                    height="18"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    style={{ marginLeft: 'auto' }}
                >
                    <path d="M4 6L8 10L12 6" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
            </Header>
            <ContentWrapper>
                <ContentTitle fontSize={16} color={'#F9F9F9'} fontFamily="var(--font-inter)" textAlign="left">
                    {t('homepage/aiSummaryUnitTitle')}
                </ContentTitle>

                <StyledList>
                    {listItems.map((item, index) => (
                        <StyledListItem key={index}>
                            <Body2 color={theme.colors.grayScaleSecondary} fontFamily="var(--font-inter)" textAlign="left">
                                {item}
                            </Body2>
                        </StyledListItem>
                    ))}
                </StyledList>
            </ContentWrapper>
        </AssetWrapper>
    )
}

export default AiSummaryAsset
